export default __webpack_public_path__ + "static/media/img_1.8440f92f.jpg";